import React from 'react';
import { createRoot } from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';

import './index.css';
import '@web-shared/styles/theme';
import App from './App.tsx';

import './i18n';

// DATADOG
if (process.env.DATADOG_APP_ID && process.env.DATADOG_CLIENT_TOKEN) {
  datadogRum.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    applicationId: process.env.DATADOG_APP_ID,
    site: process.env.DATADOG_SITE,
    service: 'ebol-manager',
    // Specify a version number to identify the deployed version of your application in Datadog
    version: `1.0.0+${process.env.BUILD_NUMBER!}`,
    env: process.env.FRONT_ENV,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    enableExperimentalFeatures: ['clickmap'],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
  });
  datadogRum.startSessionReplayRecording();
}

createRoot(document.getElementById('root')!).render(
  <App />
);
